import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=0684bb51&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=0684bb51&lang=scss&scoped=true"
import style1 from "./ColorPicker.vue?vue&type=style&index=1&id=0684bb51&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0684bb51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0684bb51')) {
      api.createRecord('0684bb51', component.options)
    } else {
      api.reload('0684bb51', component.options)
    }
    module.hot.accept("./ColorPicker.vue?vue&type=template&id=0684bb51&scoped=true", function () {
      api.rerender('0684bb51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ColorPicker.vue"
export default component.exports